/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Dashboard_Detail_PeakInputs */



/**
* | output |
* | --- |
* | "Peak users" |
*
* @param {Partner_Dashboard_Detail_PeakInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_dashboard_detail_peak = /** @type {((inputs?: Partner_Dashboard_Detail_PeakInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Dashboard_Detail_PeakInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Spitzennutzer")
	return /** @type {LocalizedString} */ ("Peak users")
});